module.exports = __webpack_public_path__ + "media/images/athletes/63-209e3df2c89bf892a2cd0dde09a2fef6.png";